import { HttpContext, HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoaderService } from './loader.service';

export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);

export const skipLoader = () => new HttpContext().set(SKIP_LOADER, true);

/**
 * Usage Example:
 * this.http.get('/api/data', { 
 *   context: skipLoader() 
 * });
 */

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
    const loaderService = inject(LoaderService);
    const shouldSkip = req.context.get(SKIP_LOADER);

    if (!shouldSkip) {
        loaderService.show();
    }

    return next(req).pipe(
        finalize(() => {
            if (!shouldSkip) {
                loaderService.hide();
            }
        })
    );
};
